'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tasks = function tasks() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  var updated_tasks = void 0;

  switch (action.type) {
    case 'LOAD_TASKS':
      return action.tasks;

    case 'ADD_TASK':
      return [action.task].concat(state);

    case 'UPDATE_TASK':
      updated_tasks = state.map(function (task) {
        if (task.id === action.task.id) {
          return action.task;
        }
        return task;
      });
      return updated_tasks;

    case 'CANCEL_TASK':
      _client2.default.task.destroy(action.task);
      return state.filter(function (task) {
        return task !== action.task;
      });

    default:
      return state;
  }
};

exports.default = tasks;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/tasks.js
// module id = 116
// module chunks = 0